<!-- Use Generic Split Screen as Foundation -->
<app-generic-split-screen-modal [config]="genericConfig" (keydown)="onKeyDown($event)" tabindex="0">
  <!-- Left Content - Form Section -->
  <div slot="left-content" class="split-screen-form-panel">
    <!-- Wrapper for ALL form content -->
    <div class="left-panel-wrapper">
      <!-- Form Loading State -->
      <div *ngIf="config.isLoading" class="form-loading-container">
        <div class="loading-content">
          <mat-spinner [diameter]="48" color="primary"></mat-spinner>
          <div class="loading-text">
            <div class="loading-title">{{ config.formLoadingText }}</div>
            <div class="loading-subtitle">{{ config.formLoadingSubtext }}</div>
          </div>
        </div>
      </div>

      <!-- Form Content (hidden when loading) -->
      <div *ngIf="!config.isLoading" class="content-layout-area">
        <ng-content select="[slot=header-content]"></ng-content>
        <div class="form-content">
          <!-- Form Content - Content Projection -->
          <ng-content select="[slot=form-content]"></ng-content>

          <!-- Submit Button -->
          <div class="cmt-5">
            <app-pencil-button
              [theme]="PencilButtonThemeEnum.PRIMARY"
              [label]="config.submitButtonText"
              icon="check"
              [iconConfig]="{ type: IconTypes.matIcon }"
              [disabled]="config.isSubmitDisabled"
              buttonType="submit"
              (clickEvent)="onSubmit()"
            >
            </app-pencil-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Content - Preview Section -->
  <div slot="right-content" class="split-screen-preview-panel">
    <!-- Preview Content - Content Projection -->
    <div class="split-screen-preview-content">
      <ng-content select="[slot=preview-content]"></ng-content>
    </div>
  </div>
</app-generic-split-screen-modal>
